module.exports = __webpack_public_path__ + "img/banners.3c2f8976.svg";